import { Box, Icon } from '@ace-clublabs/shared-component-library';
import { NewJoinConfirmationData } from '@lib/types';
import { StatelessConfirmationCard, StatelessConfirmationItemDetails } from './StatelessConfirmationCard';
import { IconName } from '@ace-clublabs/shared-component-library/dist/components/Icons';

export const StatelessPaymentDetails = (confirmation: NewJoinConfirmationData) => {
  const { paymentDetails, amount, autoPayStatus } = confirmation!;
  const { card, paymentType } = paymentDetails!;
  const { brand, last4 } = card || {};

  const getIconForCard = (cardBrand: string | undefined) => {
    switch (cardBrand?.toLowerCase()) {
      case 'visa':
        return 'visa-logo';
      case 'american-express':
      case 'americanexpress':
      case 'amex':
        return 'amex-logo';
      case 'dinersclub':
      case 'discover':
        return 'discover-logo';
      case 'jcb':
        return 'jcb-logo';
      case 'unionpay':
        return 'union-pay-logo';
      case 'maestro':
      case 'mastercard':
        return 'mastercard-logo';
      default:
        return null;
    }
  };

  const getPaymentMethodDetails = (): string | JSX.Element => {
    switch (paymentType) {
      case 'Apple Pay':
        return <Icon iconName="apple-pay-logo" className="apple-pay-logo" sx={{ fontSize: '2.75rem' }} />;
      case 'Google Pay':
        return (
          <Icon
            iconName="google-pay-logo"
            className="google-pay-logo"
            sx={{ fontSize: '4.75rem', marginLeft: '-0.75rem', marginTop: '-0.75rem', marginBottom: '-0.75rem' }}
          />
        );
      default: {
        const text = paymentType ?? '';
        return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
      }
    }
  };

  const getPaymentDetailItems = () => {
    const paymentDetailsItems: StatelessConfirmationItemDetails[] = [
      {
        title: 'Amount paid today:',
        details: `$${amount}`,
        className: 'amount-paid',
      },
    ];

    paymentDetailsItems.push({
      title: 'Payment method:',
      details: getPaymentMethodDetails(),
      cardLastFour: last4,
      iconName: getIconForCard(brand) as IconName,
      className: 'payment-method',
    });

    paymentDetailsItems.push({
      autoPayEnrolled: autoPayStatus === 'succeeded' ? true : false,
      className: 'autopay-enrolled-status',
    });

    return paymentDetailsItems;
  };

  return (
    <Box className="payment-details-container">
      <StatelessConfirmationCard cardTitle="Payment details" items={getPaymentDetailItems()} />
    </Box>
  );
};
